import { useCurrentTeam } from '@/providers/TeamProvider';
import {
  useInvalidateTeamPurchaseOrderPhases,
  useTeamPurchaseOrderPhases,
} from '@/hooks/api/0260_team_purchase_order_phases';
import { SimpleTextFormat } from '@/components/element/SimpleTextFormat';
import { Link } from 'react-router-dom';
import { useLoading } from '@/providers/LoadingProvider';
import { useSyncSalesOrderPhases } from '@/hooks/api/2590_sync_sales_order_phases';
import { useInvalidateTeamSalesOrderPhases } from '@/hooks/api/0250_team_sales_order_phases';
import { useEffect } from 'react';
import { toastApiError, toastSuccess } from '@/lib/toast';
import { useSyncPurchaseOrderPhases } from '@/hooks/api/2600_sync_purchase_order_phases';
import { ModalConfirm } from '@/components/element/modal/ModalConfirm';

export const PurchaseOrderPhasesElement = () => {
  const { setShowLoading } = useLoading();
  const { _w_, me, _t_, isAdmin } = useCurrentTeam();
  const { data: phases } = useTeamPurchaseOrderPhases({ identifier: _w_!.identifier, team_id: _t_!.id });
  const { mutate, data, isPending, error } = useSyncPurchaseOrderPhases();
  const { invalidate } = useInvalidateTeamPurchaseOrderPhases({ identifier: _w_!.identifier, team_id: _t_!.id });

  useEffect(() => setShowLoading(isPending), [isPending]);
  useEffect(() => toastApiError(error), [error]);

  useEffect(() => {
    if (data) {
      toastSuccess('スペースのフェーズ情報を反映しました');
      invalidate();
    }
  }, [data]);

  const onSyncClick = () => {
    mutate({ identifier: _w_!.identifier, team_id: _t_!.id });
  };

  return (
    <div className="card mb-4">
      <div className="card-header d-flex align-items-center">
        <div className="col-md-8">
          <h5 className="mb-0">チーム別フェーズ名編集（費用）</h5>
        </div>
        <div className="col-md-4 d-flex justify-content-end">
          {isAdmin && (
            <>
              <ModalConfirm
                modalId={`purchaseOrderSyncConfirm`}
                okClicked={() => onSyncClick()}
                message={'スペースのフェーズ情報を反映します。よろしいですか？'}
              />

              <button
                data-bs-toggle="modal"
                data-bs-target={`#purchaseOrderSyncConfirm`}
                className="btn bg-gradient-dark btn-icon"
              >
                <i className="fas fa-check-circle"></i>スペースのフェーズ情報を反映
              </button>
            </>
          )}
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="table-responsive">
          <table className="table align-items-center">
            <thead>
              <tr>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">フェーズ名</th>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  フェーズ説明（初期設定）
                </th>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">
                  システム連携などの留意事項
                </th>
                <th className="text-secondary opacity-7" style={{ width: 55 }}></th>
              </tr>
            </thead>
            <tbody>
              {phases?.map((phase) => (
                <tr key={`purchase-phase-${phase.id}`}>
                  <td>
                    <h6 className="mb-0">{phase.label}</h6>
                  </td>
                  <td className="text-secondary text-xs text-wrap">
                    <SimpleTextFormat content={phase.description} />
                  </td>
                  <td className="text-secondary text-xs text-wrap">
                    <SimpleTextFormat content={phase.note || ''} />
                  </td>
                  <td>
                    {isAdmin && (
                      <Link
                        to={`/w/${_w_!.identifier}/setting/teams/${_t_!.id}/team_purchase_order_phases/${
                          phase.id
                        }/edit`}
                        className="btn btn-icon-only btn-outline-success"
                      >
                        <i className="fas fa-edit text-success text-sm"></i>
                      </Link>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
